import { Link } from 'react-router-dom';
import Brand from './Brand';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-main">
      <div>
        <Brand dark />
        <p>L’infrastructure qui redonne le pouvoir aux créateurs de Madagascar.</p>
        <div className="socials">
          <a href="https://www.facebook.com/profile.php?id=61588887065155" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fa-brands fa-facebook-f" />
          </a>
          <a href="https://www.youtube.com/@PassioSessions" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fa-brands fa-youtube" />
          </a>
        </div>
      </div>
      <div>
        <h4>Liens</h4>
        <a href="#concept">Concept</a>
        <a href="#ecosystem">Écosystème</a>
        <a href="#pricing">Offres</a>
        <Link to="/contact">Contact</Link>
        <a href="https://passiio.shop" target="_blank" rel="noopener noreferrer">Boutique Fans</a>
      </div>
      <div>
        <h4>Légal</h4>
        <Link to="/terms">CGU</Link>
        <Link to="/privacy">Confidentialité</Link>
        <Link to="/legal">Mentions légales</Link>
      </div>
      <div>
        <h4>Les actus de l’industrie musicale Mada</h4>
        <p>Recevez nos nouveautés directement dans votre boîte mail.</p>
        <div className="newsletter">
          <input placeholder="votre@email.com" type="email" />
          <button type="button">Ok</button>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <span>© 2026 Pass’io Madagascar — Fait avec passion à Tana.</span>
      <span>Made for the culture.</span>
    </div>
  </footer>
);

export default Footer;
